// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import PropTypes from 'prop-types';

import { saveFile } from '@ion/components';
import { Button, Download02Icon } from '@metarouter-private/mr-mui';

const Export = ({ properties, eventName }) => {
  const disabled = !properties;
  return (
    <Button
      disabled={disabled}
      onClick={() => {
        if (!disabled) {
          saveFile({
            compressFile: false,
            mimeType: 'text/json',
            content: properties,
            filename: `${eventName}.json`,
          });
        }
      }}
      startIcon={<Download02Icon />}
      size="medium"
      variant="outlined"
    >
      Export as JSON
    </Button>
  );
};

Export.propTypes = {
  properties: PropTypes.object.isRequired,
  eventName: PropTypes.string.isRequired,
};

export default Export;
